import React from 'react';
import { ConfidenceLevel } from '../../utils/confidenceIndex';

export interface ConfidenceIndexBadgeProps {
  level: ConfidenceLevel;
  label: string;
  /** جزئیات کامل — در title/tooltip نمایش داده می‌شود. */
  detail?: string;
  className?: string;
  /** inline: کنار ChartControls | overlay: گوشه کارت */
  variant?: 'inline' | 'overlay';
}

/**
 * Badge شاخص اعتماد — هم‌تراز و هم‌سبک با دکمه‌های ChartControls.
 */
const ConfidenceIndexBadge: React.FC<ConfidenceIndexBadgeProps> = ({
  level,
  label,
  detail,
  className = '',
  variant = 'inline',
}) => {
  const isWarning = level === 'warning';

  return (
    <span
      className={`${
        variant === 'overlay' ? 'absolute top-2 left-2 z-10' : ''
      } inline-flex items-center gap-2 h-10 max-w-full rounded-full bg-bg-secondary px-4 text-xs font-medium text-text-secondary whitespace-nowrap transition-all duration-300 hover:bg-bg-tertiary ${className}`}
      title={detail ?? label}
      dir="rtl"
    >
      <span
        className="w-2 h-2 rounded-full shrink-0"
        style={{ backgroundColor: isWarning ? 'var(--accent-orange)' : 'var(--status-success)' }}
        aria-hidden="true"
      />
      <span className="truncate">{label}</span>
    </span>
  );
};

export default ConfidenceIndexBadge;
